<app-header></app-header>

<div class="container" *ngIf="status$ | async as status">
  <h2 translate>UI.Auth.SetNewPassword</h2>

  <div *ngIf="status === PasswordResetStatus.Success">
    <p translate>UI.Auth.PasswordHasBeenReset</p>

    <p><a routerLink="/login" translate>UI.Auth.BackToLogin</a></p>
  </div>

  <form novalidate (submit)="send()" *ngIf="status !== PasswordResetStatus.Success">
    <app-password-input
      [inputControl]="form.controls.password"
      [required]="true"
      [hint]="'User.Password.ToolTip' | translate"
      labelTextId="User.NewPassword"
      subscriptSizing="dynamic"
    >
    </app-password-input>

    <app-password-input
      [inputControl]="form.controls.confirmation"
      [required]="true"
      labelTextId="User.ConfirmNewPassword"
      subscriptSizing="dynamic"
    ></app-password-input>

    <mat-error
      class="passwords-not-match"
      *ngIf="form.controls.confirmation.dirty && form.errors && form.errors['passwordNoMatch']"
      translate
    >
      UI.Auth.PasswordsDoNotMatch
    </mat-error>

    <div class="form-button submit-button">
      <button mat-flat-button color="primary" type="submit" [disabled]="status === PasswordResetStatus.Resetting || form.invalid">
        {{ 'UI.Auth.ResetPassword' | translate }}
      </button>
    </div>
  </form>
</div>
